<div mat-dialog-content>
  <p>{{'label.enter_shipment_no' | translate}}</p>
  <mat-form-field appearance="fill">
    <mat-label>{{'table.shipment_no' | translate}}</mat-label>
    <input matInput [(ngModel)]="data.shipmentNo">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="data.shipmentNo" cdkFocusInitial>Ok</button>
</div>